import asl from "./images/asl.png";
import minigolf from "./images/minigolf.png";
import sd from "./images/sd.png";
import sdb from "./images/sdb.png";
import sp from "./images/sp.png";
import spb from "./images/spb.png";
import skinbase from "./images/skin+base.png";
import wrfc from "./images/wrfc.png";
import wrfcPage from "./images/wrfcPage.png";

const projectImages = {
  "./images/asl.png": asl,
  "./images/skinbase.png": skinbase,
  "./images/minigolf.png": minigolf,
  "./images/sd.png": sd,
  "./images/sdb.png": sdb,
  "./images/sp.png": sp,
  "./images/spb.png": spb,
  "./images/wrfc.png": wrfc,
  "./images/wrfcPage.png": wrfcPage,
};

export function resolveProjectImage(path) {
  return projectImages[path] || path;
}
